<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <!-- KAMPAGNENINFORMATIONEN -->
        <div id="headerWrapper">
            <transition name="fade" mode="out-in">
                <div :key="0" v-if="campaignLoaded">
                    <div id="headlineContainer">
                        <h2 v-if="headline">
                            <span :class="[getStatus]" class="totalStatus icon icon-status-inprogress"></span>
                            {{ headline }}
                        </h2>
                    </div>
                    <div id="headerContainer">
                        <div class="campaignDetails">
                            <InputDetail class="trcklstInput" label="Kunde"
                                         :value="campaign ? campaign.customer : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="trcklstInput" label="Kampagne"
                                         :value="campaign ? campaign.name : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="trcklstInput" label="AdSpecial"
                                         :value="campaign.ad_special ? campaign.ad_special.name : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="trcklstInput" label="Ansprechpartner"
                                         :value="campaign ? campaign.contact_person : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="trcklstInput" label="Abteilung"
                                         :value="campaign  ? campaign.department : ''"
                                         :disabled=true></InputDetail>
                        </div>
                        <Navbox :style="{width: '250px'}" class="navBox" v-if="navBox">
                            <div v-for="item in navBox" :key="item.text" @click="item.onclick($event, item.params)">
                                {{ item.text }}
                            </div>
                            <template v-slot:noStyling>
                                <div class="flex">
                                    <AdaButton title="Vorlagen anzeigen" type="createButton blue"
                                               customStyles="margin-top: 10px; padding: 8px 10px; width: 200px;"
                                               @click="openTrackingListTemplates"></AdaButton>
                                </div>
                            </template>
                        </Navbox>
                    </div>
                </div>

                <div :key="1" v-else class="loaderContainer">
                    <dot-loader id="loader"></dot-loader>
                </div>
            </transition>
        </div>
        <transition name="fade" mode="out-in">
            <div v-if="trackingListLoaded">
                <div :key="1" id="trackinglistWrapper" :style="{height: trackinglistHeight}">
                    <div id="trackinglistContainer" class="clearfix" ref="trackinglistContainer"
                         :style="{left: positionLeft, width: getContentWidth, top:positionTop}">
                        <!-- GENERELLER HEADER DER TRACKINGLISTE -->
                        <HandyScroll class="handscrolls" ref="trackinglistScroll">
                            <div id="trackingHeader">
                                <div id="generalHeader"
                                     :style="{minWidth: tableTopWidth+'px', maxWidth: tableTopWidth+'px'}">
                                    <div style="display: flex; flex-flow: row">
                                        <AdaButton style="margin-right: 10px" type="outlined noPadding" title=""
                                                   icon="icon-visible"
                                                   @click="alert('TODO')"></AdaButton>
                                    </div>
                                    <div>
                                        <AdaButton type="createButton" title="Space hinzufügen" icon="icon-add"
                                                   @click="showCreateSpace = true"></AdaButton>
                                    </div>
                                </div>
                                <div id="reportingHeader" v-if="showReporting">
                                    <KPIBox v-for="(insertionOrder, i) in insertionOrderOrSites"
                                            :key="'kpi_'+i"
                                            :style="i % 2 === 0 ? vuexState.kpiStyles.kpi_odd : vuexState.kpiStyles.kpi_even"
                                            :engagementHash="findOriginalInsertionOrder(insertionOrder).engagement_hash">
                                        <InfoBubble color="pink" :is-filled="true" :disabled="true" icon="icon-info"
                                                    :iconStyle="vuexState.kpiStyles.kpiIcon"
                                                    :iconHover="getSites(findOriginalInsertionOrder(insertionOrder))">
                                            {{ insertionOrder.name ? insertionOrder.name : insertionOrder.type }}
                                        </InfoBubble>
                                        <InfoBubble color="blue" :is-filled="true" :disabled="true"
                                                    :iconStyle="vuexState.kpiStyles.kpiIcon">
                                            {{
                                                getFullDate(findOriginalInsertionOrder(insertionOrder).dates)
                                            }}
                                        </InfoBubble>
                                        <InfoBubble color="white" :is-filled="true" :disabled="true" icon="icon-info"
                                                    icon-color="#d0d4da" :iconStyle="vuexState.kpiStyles.kpiIcon"
                                                    :iconHover="getImpressions(findOriginalInsertionOrder(insertionOrder))">
                                            {{
                                                totalAIs(findOriginalInsertionOrder(insertionOrder))
                                            }}
                                        </InfoBubble>
                                    </KPIBox>
                                </div>
                            </div>

                            <!-- TRACKINTGTABELLE -->
                            <div id="trackinglistContent">
                                <AdaDatatable style="margin-top: 10px;" :style="{width: adaDatatableWidth}"
                                              :columns="columnsWithReporting"
                                              :data="[]" :stickyFirstCol="stickyFirstCol" class="mainTable"
                                              :show-search="false" @domReady="initDatatable"></AdaDatatable>
                                <SlotAccordion style="margin-top:5px" title="Zusammenfassung"
                                               @accordionCollapse="setTrackinglistHeight"
                                               :disable-duplicate="true" :disable-delete="true" :sticky="stickyFirstCol"
                                               :disable-add="true" :style="{width: totalTableWidth + 'px'}"
                                               :startOpen="false"
                                >
                                    <template v-slot:content>
                                        <div v-if="formulaReady">
                                            <TrackingRow v-for="(formula, i) in formulas"
                                                         :key="'formula_'+i+'_'+formulaEditEvent"
                                                         :data="formula" :showReporting="showReporting"
                                                         :sticky="stickyFirstCol"
                                                         type="formula"
                                                         @delete="deleteFormula"
                                                         @edit="openEditFormulaDialog"
                                                         @rendered="setTrackinglistHeight"
                                            ></TrackingRow>
                                            <TrackingRow v-if="formulaReady" :data="'Formel hinzufügen'" type="button"
                                                         :sticky="stickyFirstCol"
                                                         @click="addFormulaDialog = true;"></TrackingRow>
                                        </div>
                                    </template>
                                </SlotAccordion>
                                <template v-for="(space, index) in trackingList.spaces">
                                    <SlotAccordion v-bind:key="index + 'tlSpace'" :title-editable="true"
                                                   :sticky="stickyFirstCol" :showMoveIcons="true" :move-index="index"
                                                   @moveUp="moveUp" @moveDown="moveDown"
                                                   @accordionCollapse="setTrackinglistHeight"
                                                   @created="setTrackinglistHeight"
                                                   @addElement="openTemplateSelectionForSpace(index)"
                                                   @spaceNameChanged="spaceNameChanged($event, index)"
                                                   @deleteElement="tryToDeleteSpace(index)"
                                                   @copyElement="copySpace(index)"
                                                   @editSpaceClicked="editSpaceClicked(space, index)"
                                                   :title="space.name" :style="{width: totalTableWidth + 'px'}"
                                                   :startOpen="index === 0 || !space.initial" type="space"
                                                   :space="space"
                                    >
                                        <template v-slot:content>
                                            <Space :technicalName="space.technical_name" :space="space"
                                                   :showReporting="showReporting"
                                                   :sticky="stickyFirstCol" :title-editable="true"
                                                   :space-index="index"
                                                   @editSpaceClicked="editSpaceClicked"
                                                   @afterCopyModule="afterModuleCopy"
                                                   @moduleAddClicked="moduleAddClicked($event, index)"
                                                   @moduleDeleteClicked="tryToDeleteModule($event, index)"
                                                   @interactionDeleteClicked="tryToDeleteInteraction($event, index)"
                                                   @interactionCopyClicked="copyInteraction($event, index)"
                                                   @addClicked="openTemplateSelectionForSpace(index)"
                                            ></Space>
                                        </template>
                                    </SlotAccordion>
                                </template>
                            </div>
                            <div style="height: 48px" class="bottom-bar" v-on:mouseover="bottomBarHovered = true"
                                 @mouseout="bottomBarHovered = false"
                                 @click="showCreateSpace = true" :class="{sticky: stickyFirstCol}">
                                <AdaButton v-on:mouseover="bottomBarHovered = true" @mouseout="bottomBarHovered = false"
                                           :custom-styles="createButtonStyle" icon="icon-add" type="fullWidthButton"
                                           title="NEUEN SPACE HINZUFÜGEN"></AdaButton>
                            </div>

                        </HandyScroll>
                    </div>
                </div>
                <div class="save-container">
                    <AdaButton :custom-styles="{padding:'1rem 2rem'}" type="createButton"
                               title="Trackingliste SPEICHERN"
                               @click="saveTrackinglist('mainSaveButton')"
                               :loading="showButtonLoader.mainSaveButton"></AdaButton>
                </div>
            </div>
            <div :key="2" v-else class="loaderContainer">
                <dot-loader></dot-loader>
            </div>
        </transition>
        <Confirm title="Aufhebung der Sperre" :show="showUnlockingConfirm" @close="showUnlockingConfirm = false"
                 @oncancel="showUnlockingConfirm = false"
                 @onok="unlockTrackinglist"
                 :options="{confirm: {title: 'Fortfahren', icon: ''},cancel: {title: 'Abbrechen', icon:''}}">
            <div>Durch diese Aktion wird die Sperrung der Tracking-Liste aufgehoben.</div>
            <br>
            <div style="padding-top: 10px">Soll die Tracking-Liste wirklich entsperrt werden?</div>
        </Confirm>
        <Confirm title="Space löschen" :show="showConfirm" @close="showConfirm = false" @oncancel="showConfirm = false"
                 @onok="deleteSpace()" :ok-loading="showButtonLoader.actionLoading">
            <div>Soll der Space wirklich gelöscht werden?</div>
        </Confirm>
        <Confirm title="Module löschen" :show="showConfirmDeleteModule" @close="showConfirmDeleteModule = false"
                 @oncancel="showConfirmDeleteModule = false" @onok="deleteModule()"
                 :ok-loading="showButtonLoader.actionLoading">
            <div>Soll das Module wirklich gelöscht werden?</div>
        </Confirm>
        <Confirm title="Interaktion löschen" :show="showConfirmDeleteInteraction"
                 @close="showConfirmDeleteInteraction = false" @oncancel="showConfirmDeleteInteraction = false"
                 @onok="deleteInteraction()" :ok-loading="showButtonLoader.actionLoading">
            <div>Soll die Interaktion wirklich gelöscht werden?</div>
        </Confirm>
        <Confirm class="confirmLoadTrackingTemplate" title="Tracking-List Vorlage laden"
                 :show="showConfirmLoadTrackinglistTemplate"
                 @close="showConfirmLoadTrackinglistTemplate = false"
                 @oncancel="showConfirmLoadTrackinglistTemplate = false"
                 @onok="trackingListSelected()" :options="{confirm:{
                        title: 'Ok',
                        icon: 'icon-apply'
                    },
                    cancel:{
                        title: 'Abbrechen',
                        icon: 'icon-close'
                    }}" :ok-loading="showButtonLoader.actionLoading">
            <div>Die bestehende Tracking-Liste wird mit der Vorlage überschrieben.<br><br>Fortfahren?</div>
        </Confirm>
        <Confirm :key="componentKey" :to="to" :refreshKey="componentKey"
                 title="Möchtest du vorher deine Änderungen speichern?" :show="showConfirmLeave"
                 @close="showConfirmLeave = false" :okLoading="showButtonLoader.dialogSaveButton"
                 @onok="saveTrackinglist('dialogSaveButton')" @oncancel="discardChanges">
        </Confirm>
        <Dialog v-if="showTemplateSelection" :show-close-button="true" :show="showTemplateSelection"
                :has-backdrop="true" width="500px" class="templateSelection"
                @close="showTemplateSelection = false">
            <h4>Welche Elemente sollen hinzugefügt werden?</h4>
            <div class="module_interaction_dialog">
                <AdaButton title="Interactions" type="createButton blue"
                           customStyles="margin-top: 20px; padding:8px;"
                           @click="openInteractionSelection" style="margin-right: 10px"></AdaButton>
                <AdaButton :title="activeTemplateTitle" type="createButton pink"
                           customStyles="margin-top: 20px; padding:8px;"
                           @click="activeTemplateTitle === 'Spaces' ? openSpaceTemplates() : openModuleTemplates()"></AdaButton>
            </div>
        </Dialog>
        <Dialog v-if="showAddSpacesDialog" :show-close-button="true" :show="showAddSpacesDialog"
                :has-backdrop="true" width="80%" max-width="1200px" @close="closeAddSpacesDialog">
            <SelectSpacesFromTable :initial-spaces="[]"
                                   @selected="spacesSelected"></SelectSpacesFromTable>
        </Dialog>
        <Dialog v-if="showAddInteractionsDialog" :show-close-button="true" :show="showAddInteractionsDialog"
                :has-backdrop="true" width="80%" max-width="1200px" @close="closeAddInteractionsDialog">
            <SelectInteractionsFromTable :initial-interactions="[]"
                                         @selected="interactionsSelected"></SelectInteractionsFromTable>
        </Dialog>
        <Dialog v-if="showAddModulesDialog" :show-close-button="true" :show="showAddModulesDialog"
                :has-backdrop="true" width="80%" max-width="1200px" @close="closeAddModulesDialog">
            <SelectModulesFromTable :initial-modules="[]"
                                    @selected="modulesSelected"></SelectModulesFromTable>
        </Dialog>
        <Dialog v-if="showCreateSpace" :show-close-button="true" :show="showCreateSpace"
                :has-backdrop="true" width="600px" @close="showCreateSpace = false">
            <div class="newSpaceDialog">
                <h4 style="margin-top:0;">Space hinzufügen</h4>
                <div class="input-row">
                    <inputFloatLabel label="Space Name" @input="newSpaceNameChanged"
                                     :value="newSpaceName" @enter="addNewSpace"></inputFloatLabel>
                    <inputFloatLabel label="Technischer Name" @input="newSpaceTechnicalNameChanged"
                                     :value="newSpaceTechnicalName" @enter="addNewSpace"></inputFloatLabel>
                </div>
                <div class="buttonContainer">
                    <AdaButton style="margin-top: 20px; padding-right: 18px;" title="Space Hinzufügen"
                               type="createButton"
                               @click="addNewSpace()"
                               icon="icon-add"></AdaButton>
                    <AdaButton style="margin-top: 20px" title="Space aus Vorlage laden" type="createButton blue"
                               @click="openAddSpaces()"
                               icon="icon-load"></AdaButton>
                </div>
            </div>
        </Dialog>
        <Confirm title="WARNUNG: Technischer Bezeichner leer" :show="showEmptySpaceTechNameWarning"
                 @close="showEmptySpaceTechNameWarning = false"
                 @oncancel="showEmptySpaceTechNameWarning = false"
                 @onok="disableSpaceTechName"
                 :options="{confirm: {title: 'Fortfahren', icon: ''},cancel: {title: 'Abbrechen', icon:''}}">
            <div>Der technische Bezeichner wurde leer gelassen.</div>
            <div style="padding-top: 5px">Sicher fortfahren?</div>
        </Confirm>
        <Dialog v-if="showPlacementsDialog" :show-close-button="true" :show="showPlacementsDialog"
                :has-backdrop="true" width="80%" max-width="1200px" height="auto" @close="showPlacementsDialog = false"
                :custom-styles="{display: 'block', overflow: 'auto'}">
            <div class="trackinglistPlacementTitle">Platzierungen</div>
            <SlotAccordion v-for="(insertionOrder, i) in vuexState.data.medium.insertion_order"
                           :key="i+moment().valueOf()"
                           :title="insertionOrder.type" :disable-duplicate="true" :disable-delete="true"
                           :disable-add="true"
                           className="trackinglistPlacement">
                <template v-slot:content>
                    <div class="placementWrapper">
                        <PlacementSection :data="[insertionOrder]"></PlacementSection>
                    </div>
                </template>
            </SlotAccordion>
        </Dialog>

        <Dialog v-if="showEditSpace" :show-close-button="true" :show="showEditSpace"
                :has-backdrop="true" width="600px" @close="showEditSpace = false">
            <div class="newSpaceDialog">
                <h4 style="margin-top:0;">Space bearbeiten</h4>
                <div class="input-row">
                    <inputFloatLabel label="Space Name" @input="editSpaceNameChanged"
                                     :value="spaceToEdit.name" @enter="editSpace"></inputFloatLabel>
                    <inputFloatLabel label="Technischer Name" @input="editSpaceTechnicalNameChanged"
                                     :value="spaceToEdit.technical_name" @enter="editSpace"></inputFloatLabel>
                </div>
                <div class="buttonContainer">
                    <AdaButton style="margin-top: 20px; padding-right: 18px;" title="Space speichern"
                               type="createButton"
                               @click="editSpace()"
                               icon="icon-add"></AdaButton>
                </div>
            </div>
        </Dialog>
        <Dialog class="trackinglistTemplatesDialog" v-if="showTrackingListTemplates" :show-close-button="true"
                :show="showTrackingListTemplates"
                :has-backdrop="true" width="1150px" @close="showTrackingListTemplates = false">
            <div class="trackinglistTemplatesDialogBody">
                <h4 style="margin-top:0">Tracking-Liste laden</h4>
                <TabList type="div"
                         :items="trackinglistTemplateTabs"
                         :active-item-name="activeTrackinglistTab"
                         @click="updateActiveTemplateTab"></TabList>
                <div v-if="activeTrackinglistTab === 'Tracking-Liste aus Vorlage laden'">
                    <SelectTrackingListFromTable :show-headline="false"
                                                 @selectedTrackingList="saveSelectedTrackingListTemplate"></SelectTrackingListFromTable>
                </div>
                <div v-if="activeTrackinglistTab === 'Tracking-Liste aus Medium laden'">
                    <SelectTrackingListFromMedium
                        @selectedTrackingList="saveSelectedTrackingListTemplate"></SelectTrackingListFromMedium>
                </div>
            </div>
        </Dialog>
        <Dialog v-if="addFormulaDialog" :show-close-button="true" :show="addFormulaDialog"
                :has-backdrop="true" width="650px" height="auto" @close="addFormulaDialog = false"
                class="addFormulaDialog">
            <div :style="{display: 'flex', flexFlow:'column', width:'100%'}">
                <div class="trackinglistPlacementTitle">Formel hinzufügen</div>
                <div class="formulaDialogBody">
                    <InputFloatLabel width="300px" label="Technischer Spacename*" @input="alert()"
                                     value="" style="margin-bottom:20px" v-model="formulaSpacename"
                                     @enter="checkFormula"></InputFloatLabel>
                    <div style="margin-bottom: 10px;">Formel auswählen:</div>
                    <div :style="{display:'flex', flexFlow:'wrap'}">
                        <div class="standardEvents" style="width:300px; border-right: 1px solid #eceef0">
                            <div class="checkboxWrapper" v-for="(event, i) in vuexState.formulaStandardEvents"
                                 v-bind:key="'event_'+i">
                                <Checkbox :rounded="true" class="checkbox"
                                          :id="'' + event.name"
                                          @change="formulaSelectionChanged(event.name)" v-model="event.selected"
                                          :title="event.name"></Checkbox>
                                <span class="icon icon-info" v-tooltip="event.description"></span>
                            </div>
                        </div>
                        <div style="margin-left: 20px">
                            <div style="margin-bottom: 5px;" class="checkboxWrapper">
                                <Checkbox :rounded="true" class="checkbox"
                                          id="Eigene Formel" style="margin-left: 0"
                                          @change="formulaSelectionChanged(customFormula.name, true)"
                                          v-model="customFormula.selected"
                                          title="Eigene Formel"></Checkbox>
                                <span class="icon icon-info" v-tooltip="'Stelle deine eigene Formel zusammen'"></span>
                            </div>
                            <InputFloatLabel width="280px" label="Formel Name*" @input="alert()"
                                             :disabled="!customFormula.selected"
                                             value="" style="margin-bottom:15px" v-model.trim="customFormula.name"
                            ></InputFloatLabel>
                            <InputFloatLabel width="280px" label="Dividend (Zähler)*" @input="alert()"
                                             :disabled="!customFormula.selected"
                                             value="" style="margin-bottom:15px" v-model.trim="customFormula.dividend"
                            ></InputFloatLabel>
                            <InputFloatLabel width="280px" label="Divisor (Nenner)*" @input="alert()"
                                             :disabled="!customFormula.selected"
                                             value="" style="margin-bottom:15px" v-model.trim="customFormula.divisor"
                            ></InputFloatLabel>
                            <InputFloatLabel width="280px" label="Beschreibung" @input="alert()"
                                             :disabled="!customFormula.selected"
                                             value="" style="margin-bottom:15px"
                                             v-model.trim="customFormula.description"
                                             @enter="checkFormula"
                            ></InputFloatLabel>
                        </div>
                    </div>
                    <AdaButton style="width: fit-content" type="createButton" title="Formel hinzufügen"
                               @click="checkFormula"></AdaButton>
                </div>
            </div>
        </Dialog>
        <Dialog v-if="showEditFormulaDialog" :show-close-button="true" :show="showEditFormulaDialog"
                :has-backdrop="true" width="500px" height="auto" @close="showEditFormulaDialog = false"
                class="addFormulaDialog">
            <div :style="{display: 'flex', flexFlow:'column', width:'100%'}">
                <div class="trackinglistPlacementTitle">Formel bearbeiten</div>
                <div class="formulaDialogBody">
                    <InputFloatLabel width="100%" label="Formel Name"
                                     value="" style="margin-bottom:20px" v-model.trim="editFormula.name"
                                     @enter="saveFormula"></InputFloatLabel>
                    <InputFloatLabel width="100%" label="Technischer Space Name"
                                     value="" style="margin-bottom:20px" v-model.trim="editFormula.spacename"
                                     @enter="saveFormula"></InputFloatLabel>
                    <InputFloatLabel width="100%" label="Dividend (Zähler)"
                                     value="" style="margin-bottom:20px" v-model.trim="editFormula.dividend"
                                     @enter="saveFormula"></InputFloatLabel>
                    <InputFloatLabel width="100%" label="Divisor (Nenner)"
                                     value="" style="margin-bottom:20px" v-model.trim="editFormula.divisor"
                                     @enter="saveFormula"></InputFloatLabel>
                    <InputFloatLabel width="100%" label="Beschreibung"
                                     value="" style="margin-bottom:20px" v-model.trim="editFormula.description"
                                     @enter="saveFormula"></InputFloatLabel>
                    <AdaButton style="width: fit-content" type="createButton" title="Übernehmen"
                               @click="saveFormula"></AdaButton>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Utils from '../../scripts/utils';
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import InputDetail from "../../components/inputs/InputDetail";
import Navbox from "../../components/navBox/Navbox";
import AdaButton from "../../components/buttons/AdaButton";
import Confirm from "../../components/dialog/Confirm";
import KPIBox from "../../components/kpiBox/KPIBox";
import InfoBubble from "../../components/inputs/InfoBubble";
import AdaDatatable from "../../components/tables/AdaDatatable";
import SelectSpacesFromTable from "../templates/spaces/SelectSpacesFromTable";
import Dialog from "../../components/dialog/Dialog";
import SelectInteractionsFromTable from "../templates/modules/SelectInteractionsFromTable";
import Space from "./Space";
import SlotAccordion from "../../components/accordion/SlotAccordion";
import SelectModulesFromTable from "../templates/spaces/SelectModulesFromTable";
import InputFloatLabel from "../../components/inputs/InputFloatLabel";
import SelectTrackingListFromTable from "../templates/trackingLists/SelectTrackingListFromTable";
import HandyScroll, {EventBus} from "vue-handy-scroll";
import TrackingRow from "./TrackingRow";
import Checkbox from "../../components/inputs/Checkbox";
import TabList from "../../components/tablist/TabList";
import SelectTrackingListFromMedium from "./SelectTrackingListFromMedium";
import PlacementSection from "../campaign/show/PlacementSection";
import moment from 'moment';

export default {
    name: "TrackingList",
    components: {
        SelectTrackingListFromMedium,
        TabList,
        Checkbox,
        TrackingRow,
        Space,
        AdaDatatable,
        InfoBubble,
        KPIBox,
        Confirm,
        AdaButton,
        Navbox,
        InputDetail,
        BreadCrumb,
        SelectSpacesFromTable,
        SelectInteractionsFromTable,
        SelectModulesFromTable,
        Dialog,
        SlotAccordion,
        InputFloatLabel,
        SelectTrackingListFromTable,
        HandyScroll,
        PlacementSection
    },
    data: function () {
        return {
            showEditSpace: false,
            spaceToEdit: null,
            stickyFirstCol: true,
            showTrackingListTemplates: false,
            showReporting: true,
            formulaReady: false,
            interactionDeleteData: {
                moduleId: null,
                interactionId: null,
                spaceId: null
            },
            showConfirmDeleteInteraction: false,
            moduleDeleteData: {
                moduleId: null,
                spaceId: null
            },
            showConfirmDeleteModule: false,
            showConfirmLoadTrackinglistTemplate: false,
            editSpaceName: '',
            editSpaceTechnicalName: '',
            newSpaceName: '',
            newSpaceTechnicalName: '',
            showCreateSpace: false,
            activeTemplateTitle: 'Spaces',
            activeSpace: null,
            activeModule: null,
            addInteractionMode: 'trackinglist',
            ADD_INTERACTION_MODES: {
                MODULE: 'module',
                SPACE: 'space',
            },
            showAddInteractionsDialog: false,
            showAddModulesDialog: false,
            showTemplateSelection: false,
            showEmptySpaceTechNameWarning: false,
            allowEmptyTechName: false,
            indexOfSpaceToDelete: null,
            bottomBarHovered: false,
            showAddSpacesDialog: false,
            addFormulaDialog: false,
            trackingListLoaded: false,
            campaignLoaded: false,
            showConfirm: false,
            showEditFormulaDialog: false,
            showPlacementsDialog: false,
            showTrackinglist: false,
            selectedTrackinglistTemplate: null,
            styles: {
                inputWidth: '300px',
            },
            leftPosition: 0,
            topPosition: 370,
            contentWidth: document.documentElement.clientWidth,
            trackinglistHeight: '100vh',
            next: null,
            from: null,
            to: null,
            showConfirmLeave: false,
            componentKey: 0,
            removeFromTableTopWidth: 0,
            adaDatatableWidth: '100%',
            selectedFormula: null,
            formulaSpacename: '',
            editFormula: {
                name: '',
                spacename: '',
                dividend: '',
                divisor: '',
                description: '',
                order: '',
            },
            originalFormulaSpace: '',
            allowSpaceTechnicalNameToBeEmpty: false,
            showButtonLoader: {
                mainSaveButton: false,
                dialogSaveButton: false,
                actionLoading: false
            },
            trackinglistTemplateTabs: [{
                name: 'Tracking-Liste aus Vorlage laden'
            }, {
                name: 'Tracking-Liste aus Medium laden'
            }],
            activeTrackinglistTab: 'Tracking-Liste aus Vorlage laden',
            showUnlockingConfirm: false,
            callAferUnlock: null,
            fn: null,
            commentCol: null,
            customFormula: {
                name: null,
                dividend: null,
                divisor: null,
                description: null,
                selected: false,
                order: null,
            },
            formulaEditEvent: 0,
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.vuexState.changesMade) {
            this.to = to.path;
            this.from = from;
            this.showConfirmLeave = true;
            this.next = next;
            this.forceRerender();
        } else {
            next();
        }
    },
    computed: {
        createButtonStyle: function () {
            let res = '';
            let bgColor = !this.bottomBarHovered ? 'white' : 'rgb(215,4,101)';
            let textColor = !this.bottomBarHovered ? 'rgb(215,4,101)' : 'white';
            res = `background-color: ${bgColor};color: ${textColor};`;
            return res;
        },
        vuexState() {
            return this.$store.state.trackingList;
        },
        getStatus() {
            if (this.vuexState.data.status === "in Arbeit") {
                return "grey";
            } else if (this.vuexState.data.status === "gecheckt") {
                return "blue";
            } else if (this.vuexState.data.status === "eingebaut" || this.vuexState.data.status === "nicht eingebaut") {
                return 'pink';
            } else {
                return 'grey';
            }
        },
        containerHeight() {
            return this.$store.state.trackingList.containerHeight;
        },
        headline() {
            if (this.campaign && this.vuexState.data && this.campaign.ad_special) {
                return this.campaign.customer + ': ' + this.campaign.name + ' – ' + this.campaign.ad_special.name + ' – ' + this.vuexState.data.name
            }
            return null;
        },
        campaign() {
            return this.$store.state.campaign.campaign;
        },
        navBox() {
            if (this.campaignLoaded) {
                let navBox = this.$store.getters['trackingList/navBox'];
                if (navBox) {
                    navBox.forEach((item) => {
                        item.onclick = this[item.onclick];
                    });
                }
                return navBox;
            }
            return [];
        },
        trackingList() {
            return this.$store.getters['trackingList/trackingList'];
        },
        reporting() {
            return this.$store.getters['trackingList/reporting'];
        },
        formulas() {
            let ret = this.$store.getters['trackingList/formulas'];
            if (ret.findIndex(x => x.name === 'video_sum') !== -1) ret.splice(ret.findIndex(x => x.name === 'video_sum'), 1);
            if (ret.findIndex(x => x.name === 'expand_sum') !== -1) ret.splice(ret.findIndex(x => x.name === 'expand_sum'), 1);
            return ret;
        },
        table() {
            return {
                rows: []
            }
        },
        tableTopWidth() {
            let width = 0;
            this.vuexState.columns.forEach((colObj) => {
                if (colObj.propName.indexOf("rep") === -1) {
                    width += parseInt(colObj.width);
                }
            });
            return width - this.removeFromTableTopWidth;
        },
        totalTableWidth() {
            let width = 0;
            this.columnsWithReporting.forEach((colObj) => {
                width += parseInt(colObj.width);
            });
            return width - this.removeFromTableTopWidth;
        },
        columnsWithReporting() {
            let cols = this.vuexState.columns;
            for (let i = 0; i < cols.length; i++) {
                if (cols[i].propName.indexOf('rep') === 0) {
                    cols.splice(i, 1);
                    i--;
                }
            }
            for (let i = 0; i < this.insertionOrderOrSites.length; i++) {
                cols.push({
                    viewName: 'Anzahl',
                    propName: 'repCount_' + i,
                    width: '85px',
                    styles: {padding: '5px 0', margin: '8px 0px 8px 10px'}
                });
                cols.push({
                    viewName: 'Relation zu Gesamt-AIs',
                    propName: 'repRelation_' + i,
                    width: '115px',
                    styles: {padding: '0px 4px 0px 4px', margin: '8px 0px 8px 8px'}
                });
            }
            return cols;
        },
        insertionOrderOrSites: function () {
            let abbreviations = [
                {name: 'Run of Channel', short: 'RoC'},
                {name: 'Festplatzierung', short: 'FP'},
                {name: 'Run of Site', short: 'RoS'},
            ];
            if (Object.keys(this.reporting).length > 0) {
                let ret = [];
                for (let i = 0; i < this.vuexState.data.medium.insertion_order.length; i++) {
                    let insertionOrder = this.vuexState.data.medium.insertion_order[i];
                    if (insertionOrder.sites.length === 0 && this.reporting[insertionOrder.engagement_hash + '_' + insertionOrder.id]) {
                        ret.push(insertionOrder);
                        let sites = this.reporting[insertionOrder.engagement_hash + '_' + insertionOrder.id].sites;
                        for (let j = 0; j < Object.keys(sites).length; j++) {
                            let site = this.$store.state.sites.sites.find(x => x.code === Object.keys(sites)[j]);
                            if (typeof site === 'undefined') {
                                console.log('couldn\'t find site with code', Object.keys(sites)[j]);
                            } else {
                                let tmp = {
                                    id: insertionOrder.id,
                                    notOG: true, // keyword so it takes data from parent (5 code rows above)
                                    sites: [site],
                                    type: (site ? site.name : Object.keys(sites)[j]) + ' ' + abbreviations.find(x => x.name === insertionOrder.type).short,
                                };
                                ret.push(tmp);
                            }
                        }
                    } else if (insertionOrder.sites.length > 0) {
                        ret.push(insertionOrder);
                    }
                }
                return ret;
            } else {
                return this.vuexState.data.medium.insertion_order;
            }
        },
        positionLeft: function () {
            return this.leftPosition + 'px';
        },
        positionTop: function () {
            return this.topPosition + 'px';
        },
        getContentWidth() {
            return this.contentWidth + 'px';
        },
    },
    mounted() {
        this.fn = (button) => {
            this.saveTrackinglist(button)
        };
        this.$root.$on('saveTrackinglist', this.fn);
        if (this.$store.state.sites.sites.length === 0) {
            this.$store.dispatch('sites/fetchAllAdServer');
        }
        this.$store.dispatch('campaign/fetch', this.$route.params.id).then(() => {
            this.campaignLoaded = true;
            this.setPositionTop();
        });
        this.$store.dispatch('trackingList/fetch', this.$route.params.trackinglist_id).then(() => {
            this.trackingListLoaded = true;
            this.setPositionTop();
            this.$store.dispatch('trackingList/fetchReportings', {vm: this}).then(() => {
                this.formulaReady = true;
            });
        });
        this.$store.commit('trackingList/setContentContainerRect', document.getElementById('contentContainer').getBoundingClientRect());
    },
    created() {
        window.addEventListener("resize", this.setPositionTop);
        window.addEventListener("resize", this.setAdaDatatableWidth);
        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type === 'trackingList/setInteractionProperty') {
                if (mutation.payload.property === 'status') {
                    this.showHideCommentColumn()
                }
            }
        });
    },
    beforeDestroy() {
        this.unsubscribe();
        this.$root.$off('saveTrackinglist', this.fn);
    },
    destroyed() {
        window.removeEventListener("resize", this.setPositionTop);
        window.removeEventListener("resize", this.setAdaDatatableWidth);
        window.removeEventListener('scroll', this.setTrackinglistHeight);
        this.$store.commit('trackingList/clearData');
    },
    methods: {
        editSpace() {
            if (this.editSpaceTechnicalName === "") {
                this.showEmptySpaceTechNameWarning = true;
            }
            this.showEditSpace = false;
            this.$store.commit('trackingList/editSpace', {
                name: this.editSpaceName,
                technical_name: this.editSpaceTechnicalName,
                spaceId: this.spaceEditIndex
            });
        },
        editSpaceClicked(space, index) {
            this.spaceToEdit = space;
            this.spaceEditIndex = index;
            this.editSpaceName = space.name;
            this.editSpaceTechnicalName = space.technical_name;
            this.showEditSpace = true;
        },
        afterModuleCopy() {
            this.$noty.success('Erfolgreich kopiert!');
            this.setTrackinglistHeight();
        },
        moveUp(spaceIndex) {
            this.$store.commit('trackingList/moveSpaceUp', spaceIndex);
        },
        moveDown(spaceIndex) {
            this.$store.commit('trackingList/moveSpaceDown', spaceIndex);
        },
        spaceNameChanged(name, spaceIndex) {
            this.$store.commit('trackingList/setSpaceName', {
                name: name,
                spaceIndex: spaceIndex
            });
        },
        saveSelectedTrackingListTemplate(list) {
            this.showTrackingListTemplates = false;
            this.selectedTrackinglistTemplate = list;
            if (this.vuexState.data.spaces.length !== 0) {
                this.showConfirmLoadTrackinglistTemplate = true;
            } else {
                this.trackingListSelected();
            }
            this.$store.commit('trackingList/triggerFilter');
        },
        trackingListSelected() {
            this.showButtonLoader.actionLoading = true;
            this.showConfirmLoadTrackinglistTemplate = false;
            if (typeof this.selectedTrackinglistTemplate.selectedFromMedium !== "undefined" &&
                this.selectedTrackinglistTemplate.selectedFromMedium) {
                //Trackinglist medium table
                this.trackingListLoaded = false;
                this.formulaReady = false;
                this.$store.dispatch('trackingList/loadOtherTrackinglist', {id: this.selectedTrackinglistTemplate.tracking_list_id}).then(() => {
                    this.trackingListLoaded = true;
                    this.$store.dispatch('trackingList/fetchReportings', {vm: this}).then(() => {
                        this.formulaReady = true;
                    });
                });
            } else {
                //Trackinglist templates table
                this.selectedTrackinglistTemplate.is_template = 0;
                this.selectedTrackinglistTemplate.id = this.$route.params.trackinglist_id;
                this.$store.dispatch('trackingList/loadOtherTrackinglist', {
                    id: null,
                    data: this.selectedTrackinglistTemplate
                });
            }
            this.showButtonLoader.actionLoading = false;
            this.$store.commit('trackingList/triggerFilter');
        },
        openTrackingListTemplates() {
            this.showTrackingListTemplates = true;
        },
        openPlacementDialog: function () {
            this.showPlacementsDialog = true;
        },
        copySpace(index) {
            this.$store.commit('trackingList/copySpace', index);
            this.setTrackinglistHeight();
        },
        tryToDeleteInteraction(data, spaceIndex) {
            this.interactionDeleteData = data;
            this.interactionDeleteData.spaceId = spaceIndex;
            this.showConfirmDeleteInteraction = true;
        },
        copyInteraction(data, spaceIndex) {
            this.$store.commit('trackingList/copyInteraction', {
                spaceId: spaceIndex,
                moduleId: data.moduleId,
                interactionId: data.interactionId
            });
            this.setTrackinglistHeight();
        },
        tryToDeleteModule(moduleId, spaceId) {
            this.moduleDeleteData = {
                moduleId: moduleId,
                spaceId: spaceId
            };
            this.showConfirmDeleteModule = true;
        },
        tryToDeleteSpace(spaceId) {
            this.indexOfSpaceToDelete = spaceId;
            this.showConfirm = true;
        },
        moduleAddClicked(moduleIndex, spaceIndex) {
            this.activeSpace = spaceIndex;
            this.activeModule = moduleIndex;
            this.addInteractionMode = this.ADD_INTERACTION_MODES.MODULE;
            this.showAddInteractionsDialog = true;
        },
        disableSpaceTechName() {
            this.showEmptySpaceTechNameWarning = false;
            this.allowEmptyTechName = true;
            this.addNewSpace();
        },
        addNewSpace() {
            if (this.newSpaceName === "") {
                this.$noty.warning('Bitte einen Spacenamen angeben.');
            } else if (this.newSpaceTechnicalName === "" && !this.allowEmptyTechName) {
                this.showEmptySpaceTechNameWarning = true;
            } else {
                this.showCreateSpace = false;
                if (this.vuexState.data.status === "eingebaut" && this.callAferUnlock === null) {
                    this.callAferUnlock = {method: 'addNewSpace'};
                    this.showUnlockingConfirm = true;
                } else {
                    let space = {
                        id: null,
                        name: this.newSpaceName,
                        technical_name: this.newSpaceTechnicalName,
                        medium: this.trackingList.medium,
                        interactions: [],
                        modules: []
                    };
                    this.$store.commit('trackingList/addSpaces', [space]);
                    this.setTrackinglistHeight();
                    this.newSpaceName = '';
                    this.newSpaceTechnicalName = '';
                    this.allowEmptyTechName = false;
                }
            }
        },
        editSpaceNameChanged(val) {
            this.editSpaceName = val;
        },
        editSpaceTechnicalNameChanged(val) {
            this.editSpaceTechnicalName = val;
        },
        newSpaceTechnicalNameChanged(val) {
            this.newSpaceTechnicalName = val;
        },
        newSpaceNameChanged(val) {
            this.newSpaceName = val;
        },
        openTemplateSelectionForSpace(spaceId) {
            this.activeSpace = spaceId;
            this.addInteractionMode = this.ADD_INTERACTION_MODES.SPACE;
            this.activeTemplateTitle = 'Modules';
            this.showTemplateSelection = true;
        },
        openInteractionSelection() {
            this.showTemplateSelection = false;
            this.showAddInteractionsDialog = true;
        },
        openSpaceTemplates() {
            this.showTemplateSelection = false;
            this.showAddSpacesDialog = true;
        },
        openModuleTemplates() {
            this.showTemplateSelection = false;
            this.showAddModulesDialog = true;
        },
        deleteSpace() {
            this.showButtonLoader.actionLoading = true;
            this.$store.commit('trackingList/deleteSpace', this.indexOfSpaceToDelete);
            this.showConfirm = false;
            this.showButtonLoader.actionLoading = false;
            this.setTrackinglistHeight();
        },
        deleteModule() {
            this.showButtonLoader.actionLoading = true;
            this.showConfirmDeleteModule = false;
            this.$store.commit('trackingList/deleteModule', this.moduleDeleteData);
            this.setTrackinglistHeight();
            this.showButtonLoader.actionLoading = false;
        },
        deleteInteraction() {
            this.showButtonLoader.actionLoading = true;
            this.showConfirmDeleteInteraction = false;
            this.$store.commit('trackingList/deleteInteraction', this.interactionDeleteData);
            this.setTrackinglistHeight();
            this.showButtonLoader.actionLoading = false;
        },
        spacesSelected(selectedSpaces) {
            this.showAddSpacesDialog = false;
            if (this.vuexState.data.status === "eingebaut" && this.callAferUnlock === null) {
                this.callAferUnlock = {method: 'spacesSelected', params: selectedSpaces};
                this.showUnlockingConfirm = true;
            } else {
                this.$store.commit('trackingList/addSpaces', selectedSpaces);
                this.setTrackinglistHeight();
            }
            this.$store.commit('trackingList/triggerFilter');
        },
        modulesSelected(selectedModules) {
            this.showAddModulesDialog = false;
            this.$store.commit('trackingList/addModuleToSpace', {
                spaceId: this.activeSpace,
                modules: selectedModules
            });
            this.setTrackinglistHeight();
            this.$store.commit('trackingList/triggerFilter');
        },
        interactionsSelected(selectedInteractions) {
            this.showAddInteractionsDialog = false;
            switch (this.addInteractionMode) {
                case this.ADD_INTERACTION_MODES.MODULE:
                    this.$store.commit('trackingList/addInteractionToModule', {
                        spaceId: this.activeSpace,
                        moduleId: this.activeModule,
                        interactions: selectedInteractions
                    });
                    break;
                case this.ADD_INTERACTION_MODES.SPACE:
                    this.$store.commit('trackingList/addInteractionToSpace', {
                        spaceId: this.activeSpace,
                        interactions: selectedInteractions
                    });
                    break;
            }
            this.setTrackinglistHeight();
        },
        openAddSpaces: function () {
            this.showCreateSpace = false;
            this.showAddSpacesDialog = true;
        },
        closeAddSpacesDialog: function () {
            this.showAddSpacesDialog = false;
        },
        closeAddModulesDialog: function () {
            this.showAddModulesDialog = false;
        },
        closeAddInteractionsDialog: function () {
            this.showAddInteractionsDialog = false;
        },
        twoDigitize: function (number) {
            return ("0" + number).slice(-2);
        },
        alert: function (string) {
            if (typeof string !== "undefined") {
                this.$noty.success(string);
            }
        },
        goTo: function (e, route) {
            if (route.indexOf("http") !== -1) {
                window.open(route, "_blank");
            } else {
                this.$router.push({name: route, params: {id: this.$route.params.id}});
            }
        },
        saveTrackinglist: async function (button) {
            if (button === 'headerSaveButton') {
                this.$root.$emit('trackinglistLoader', true);
            } else {
                this.showButtonLoader[button] = true;
            }
            this.$store.commit('trackingList/removeMediumStatus');
            await this.$store.dispatch('trackingList/updateLiveTrackingList');
            if (button === 'headerSaveButton') {
                this.$root.$emit('trackinglistLoader', false);
            } else {
                this.showButtonLoader[button] = false;
            }
            this.$noty.success('Erfolgreich gespeichert');
            if (this.next) this.next();
        },
        getFullDate: function (dateArr) {
            if (dateArr.length !== 0) {
                let start = dateArr[0].start;
                let end = dateArr[0].end;
                for (let i = 0; i < dateArr.length; i++) {
                    if (dateArr[i].start < start) {
                        start = dateArr[i].start;
                    }
                    if (dateArr[i].end > end) {
                        end = dateArr[i].end;
                    }
                }
                return this.formatDate(start) + ' - ' + this.formatDate(end);
            } else {
                return '...';
            }

        },
        formatDate: function (dateStr) {
            return moment(dateStr, 'YYYY-MM-DD').format('DD.MM.YY');
        },
        totalAIs(insertionOrder) {
            return Utils.calcImpressions(insertionOrder.line_items, this.vuexState.data.medium.type).totalAIs.toLocaleString('de-DE') + ' AIs';
        },
        totalClicks(insertionOrder) {
            return Utils.calcClicks(insertionOrder.line_items, this.vuexState.data.medium.type).totalClicks.toLocaleString('de-DE');
        },
        initDatatable() {
            this.calcPositionLeft();
            this.setPositionTop();
            this.setTrackinglistHeight();
            this.setAdaDatatableWidth();
            this.contentWidth = document.documentElement.clientWidth;
            this.showHideCommentColumn();
            window.addEventListener('scroll', this.setTrackinglistHeight);
        },
        calcPositionLeft() {
            this.leftPosition = 0;
            this.$store.commit('trackingList/setTableClientRect',
                document.getElementById('trackinglistContainer').getBoundingClientRect());
            if (this.$refs.trackinglistScroll.$el) {
                this.$nextTick(() => {
                    EventBus.$emit("update", this.$refs.trackinglistScroll.$el);
                });
            }
        },
        setPositionTop() {
            if (document.getElementById('trackinglistWrapper')) {
                let top = document.getElementById('trackinglistWrapper').getBoundingClientRect().top;
                if ((top + 10) >= 370) {
                    this.topPosition = top + 10;
                }
            }
        },
        setTrackinglistHeight() {
            window.requestAnimationFrame(() => {
                let trackinglistContainer = document.getElementById('trackinglistContainer');
                this.trackinglistHeight = (trackinglistContainer.getBoundingClientRect().height) + 'px';
            });
        },
        getSites(insertionOrder) {
            let ret = [];
            for (let i = 0; i < insertionOrder.sites.length; i++) {
                if (insertionOrder.sites[i].parent_code) {
                    ret.push(insertionOrder.sites[i].parent_name + ' - ' + insertionOrder.sites[i].name);
                } else {
                    ret.push(insertionOrder.sites[i].name);
                }
            }
            return ret.join(', <br>')
        },
        discardChanges() {
            this.next();
        },
        forceRerender() {
            this.componentKey += 1;
        },
        showHideCommentColumn() {
            let tableHeaders = document.querySelectorAll('#trackinglistContent .ada-table th .table-header-text');
            let commentCol;
            for (let i = 0; i < tableHeaders.length; i++) {
                if (tableHeaders[i].innerHTML.trim().toLowerCase() === "bemerkung") {
                    commentCol = tableHeaders[i].parentElement.parentElement;
                    this.commentCol = tableHeaders[i].parentElement.parentElement;
                    break;
                }
            }
            if (commentCol) {
                if (this.vuexState.showCommentSection) {
                    if (commentCol.classList.contains('hide')) {
                        commentCol.classList.remove('hide');
                        this.removeFromTableTopWidth = 0;
                    }
                } else {
                    if (!commentCol.classList.contains('hide')) {
                        commentCol.classList.add('hide');
                        this.removeFromTableTopWidth = parseInt(this.getWidthOfProp('Bemerkung'));
                    }
                }
            }
            this.setAdaDatatableWidth();
        },
        getWidthOfProp(viewName) {
            if (viewName === "Name" && this.$route.name === "showReporting") {
                return this.$store.state.trackingList.dashboard.firstColWidth;
            } else {
                for (let i = 0; i < this.vuexState.columns.length; i++) {
                    if (this.vuexState.columns[i].viewName === viewName) {
                        return this.vuexState.columns[i].width;
                    }
                }
            }
        },
        setAdaDatatableWidth() {
            if (this.commentCol) {
                if (this.totalTableWidth > window.innerWidth) {
                    this.adaDatatableWidth = 'max-content';
                } else {
                    this.adaDatatableWidth = '100%';
                }
                this.contentWidth = document.documentElement.clientWidth;
            }
        },
        formulaSelectionChanged(name, isCustomFormula) {
            this.selectedFormula = null;
            if (isCustomFormula && this.customFormula.selected) {
                //test
                this.selectedFormula = this.customFormula;
            } else {
                this.customFormula.selected = false;
            }
            this.vuexState.formulaStandardEvents.forEach(event => {
                if (event.name !== name) {
                    this.$store.commit('trackingList/resetFormulaStandardEvent', event.name);
                    //event.selected = false;
                } else if (event.selected) {
                    this.selectedFormula = event;
                }
            });
        },
        checkFormula() {
            let spacenames = [];
            let valid = true;
            this.vuexState.data.spaces.forEach((space) => {
                spacenames.push(space.technical_name);
            });
            //Techn. spacename not valid
            if (!spacenames.includes(this.formulaSpacename)) {
                valid = false;
                this.$noty.warning('Technischer Name existiert nicht. Bitte den technischen Namen von einem bereits existierenden Space angeben.');
            }
            //formula data not valid
            if (this.formulaSpacename === '' || this.selectedFormula === null) {
                valid = false;
                if (this.formulaSpacename === '' && this.selectedFormula === null) {
                    this.$noty.warning('Bitte technischen Spacenamen angeben und eine Formel auswählen.');
                } else if (this.formulaSpacename === '') {
                    this.$noty.warning('Bitte technischen Spacenamen angeben.');
                } else if (this.selectedFormula === null) {
                    this.$noty.warning('Bitte eine Formel auswählen.');
                }
            }
            //custom formula not valid
            if (this.customFormula.selected && (
                this.customFormula.name === null || this.customFormula.name === "" ||
                this.customFormula.dividend === null || this.customFormula.dividend === "" ||
                this.customFormula.divisor === null || this.customFormula.divisor === ""
            )) {
                valid = false;
                this.$noty.warning('Bitte eine alle Formel Felder ausfüllen.');
            }
            let customFormulas = this.vuexState.data.formulas.filter(x => x.id === 1);
            for (let i = 0; i < customFormulas.length; i++) {
                if (this.formulaSpacename === customFormulas[i].spacename &&
                    this.selectedFormula.name === customFormulas[i].name) {
                    valid = false;
                    this.$noty.warning('Diese Formel existiert bereits.');
                    break;
                }
            }
            if (valid) {
                if (this.customFormula.selected) {
                    this.customFormula.order = customFormulas.length;
                }
                this.addFormula();
            }
        },
        addFormula() {
            let formula = {
                id: 1,
                name: this.selectedFormula.name,
                spacename: this.formulaSpacename,
                pivot: {
                    visibility: 'intern',
                    formula_id: 1,
                    tracking_list_id: parseInt(this.$route.params.trackinglist_id),
                    name: this.selectedFormula.name,
                    spacename: this.formulaSpacename,
                    description: null,
                }
            };
            if (this.customFormula.selected) {
                formula.pivot.dividend = this.customFormula.dividend;
                formula.pivot.divisor = this.customFormula.divisor;
                formula.pivot.description = this.customFormula.description;
                formula.pivot.order = this.customFormula.order;
            }
            this.$store.commit('trackingList/addFormula', formula);
            this.addFormulaDialog = false;
            this.customFormula = {
                name: null,
                dividend: null,
                divisor: null,
                description: null,
                selected: false,
                order: null,
            };
        },
        deleteFormula(data) {
            this.$store.commit('trackingList/removeFormula', data);
        },
        openEditFormulaDialog(data) {
            this.showEditFormulaDialog = true;
            this.editFormula.name = data.pivot.name;
            this.editFormula.spacename = data.pivot.spacename;
            this.editFormula.dividend = data.pivot.dividend;
            this.editFormula.divisor = data.pivot.divisor;
            this.editFormula.description = data.pivot.description;
            this.editFormula.order = data.pivot.order;
            this.originalFormulaSpace = data.pivot;
        },
        saveFormula() {
            let spacenames = [];
            this.vuexState.data.spaces.forEach((space) => {
                spacenames.push(space.technical_name);
            });
            if (!spacenames.includes(this.editFormula.spacename)) {
                this.$noty.warning('Technischer Name existiert nicht.');
            } else if (this.originalFormulaSpace.name !== this.editFormula.name && this.vuexState.data.formulas.findIndex(x => x.name === this.editFormula.name) !== -1) {
                this.$noty.warning('Dieser Formel Name existiert bereits.');
            } else {
                this.$store.commit('trackingList/editFormula', {
                    original: this.originalFormulaSpace,
                    name: this.editFormula.name,
                    spacename: this.editFormula.spacename,
                    dividend: this.editFormula.dividend,
                    divisor: this.editFormula.divisor,
                    description: this.editFormula.description,
                    order: this.editFormula.order
                });
                this.showEditFormulaDialog = false;
                this.formulaEditEvent++;
            }
        },
        updateActiveTemplateTab(name) {
            this.activeTrackinglistTab = name;
        },
        unlockTrackinglist() {
            if (typeof this.callAferUnlock.params !== "undefined") {
                this[this.callAferUnlock.method](this.callAferUnlock.params);
            } else {
                this[this.callAferUnlock.method]();
            }
            this.showUnlockingConfirm = false;
            this.callAferUnlock = null;
        },
        getImpressions(insertionOrder) {
            let ret = [];
            let impressions = Utils.calcImpressions(insertionOrder.line_items, this.vuexState.data.medium.type);
            if (impressions.desktopAIs !== 0 || this.vuexState.data.medium.type.toLowerCase() === "online" || this.vuexState.data.medium.type.toLowerCase() === "desktop") {
                ret.push('Desktop: ' + impressions.desktopAIs.toLocaleString('de-DE') + ' AIs');
            }
            if (impressions.tabletAIs !== 0 || this.vuexState.data.medium.type.toLowerCase() === "online" || this.vuexState.data.medium.type.toLowerCase() === "tablet") {
                ret.push('Tablet: ' + impressions.tabletAIs.toLocaleString('de-DE') + ' AIs');
            }
            if (impressions.mobileAIs !== 0 || this.vuexState.data.medium.type.toLowerCase() === "mobile") {
                ret.push('Mobile: ' + impressions.mobileAIs.toLocaleString('de-DE') + ' AIs');
            }
            return ret.join('<br>');
        },
        getClicks(insertionOrder) {
            let ret = [];
            let clicks = Utils.calcClicks(insertionOrder.line_items, this.vuexState.data.medium.type);
            if (clicks.desktopClicks !== 0 || this.vuexState.data.medium.type.toLowerCase() === "online" || this.vuexState.data.medium.type.toLowerCase() === "desktop") {
                ret.push('Desktop: ' + clicks.desktopClicks.toLocaleString('de-DE'));
            }
            if (clicks.tabletClicks !== 0 || this.vuexState.data.medium.type.toLowerCase() === "online" || this.vuexState.data.medium.type.toLowerCase() === "tablet") {
                ret.push('Tablet: ' + clicks.tabletClicks.toLocaleString('de-DE'));
            }
            if (clicks.mobileClicks !== 0 || this.vuexState.data.medium.type.toLowerCase() === "mobile") {
                ret.push('Mobile: ' + clicks.mobileClicks.toLocaleString('de-DE'));
            }
            return ret.join('<br>');
        },
        findOriginalInsertionOrder(insertionOrder) {
            if (typeof insertionOrder.notOG !== "undefined" && insertionOrder.notOG) {
                let originals = this.insertionOrderOrSites.filter(x => typeof x.notOG === "undefined");
                return originals.find(x => x.id === insertionOrder.id);
            } else {
                return insertionOrder;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#headerWrapper {
    display: flex;
    flex-direction: row;
}


#headerContainer {
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    margin-bottom: 2.3rem;
}

.campaignDetails {
    display: flex;
    flex-flow: wrap;
    width: 900px;
}

.campaignDetails .inputContainer:last-child {
    margin-bottom: 0;
}

.loaderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10em;
}

.trcklstInput {
    margin-bottom: 18px;
    margin-right: 20px;
    width: 270px;
}

#trackinglistWrapper {
    transition: all 0.3s ease-in-out;
}

#trackinglistContainer {
    position: absolute;
    left: 0;
    top: 350px;
    overflow-x: auto;
    display: flex;
    flex-flow: column;
}

#trackingHeader {
    height: 100px;
    display: flex;
    flex-flow: row;
    background: #fff;
}

#generalHeader {
    background: white;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-flow: row;
    align-items: flex-end;
    padding: 1em;
    width: 100%;
    transition: all .3s ease-in-out;
}

.input-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.save-container {
    margin: 50px 0 40px 0;
    display: flex;
    width: 100%;
    align-items: center;
}

#reportingHeader {
    display: flex;
    flex-flow: row;
}

#reportingHeader {
    display: flex;
    flex-flow: row;
}

::v-deep .trackinglistPlacementTitle {
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
    font-weight: bold;
    color: #555;
}

::v-deep .slot-accordion-wrapper.trackinglistPlacement {
    margin: 0;
    width: 100%;

    .actionBar {
        border: 1px solid #d0d4da;
        min-height: 30px;

        .title {
            padding-left: 14px !important;
        }
    }

    .title {
        color: #555;
    }

    .placementWrapper {
        background-color: $oddTableRow;
        padding: 1rem;
    }

    .placementContainer {
        h4 {
            font-size: .9rem;
        }
    }
}

::v-deep .ada-table-container {
    .table-header {
        margin: 8px 0px 8px 10px;
    }

    thead > tr > th:nth-child(5) > .table-header {
        padding-right: 0;
    }

    .sticky {
        padding-left: 10px;
    }

}

::v-deep .newSpaceDialog {
    width: 100%;

    .input-row > .inputContainer {
        width: 50%;
        padding-right: 18px;

        &:last-child {
            padding-right: 0;
        }
    }

    .buttonContainer {
        display: flex;
        flex-flow: wrap;

        .createButton {
            padding: 7px 20px;
        }
    }
}

::v-deep .modal-container {
    padding: 20px;
}

::v-deep .trackinglistTemplatesDialog {
    .trackinglistTemplatesDialogBody {
        width: 100%;
    }

    .select-button {
        background: $blue;
        border-radius: 5px;
        border: 1px solid $blue;
        text-transform: uppercase;
        padding: 8px 35px;
        font-size: 12px;
        color: white;
        cursor: pointer;
    }

    table tbody tr td {
        padding: 7px 15px;
        display: flex;
        align-items: center;

        &:last-child {
            padding: 2px 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

::v-deep .confirmLoadTrackingTemplate {
    .dialogCancel .icon {
        font-size: 12px;
        margin-right: 10px;
    }
}

.totalStatus {
    font-size: 13px;
    margin-right: 15px;

    &.grey {
        color: $grey;
    }

    &.pink {
        color: $pink;
    }

    &.blue {
        color: $blue;
    }
}

::v-deep .handy-scroll {
    z-index: 10;
}

.sticky {
    position: sticky !important;
    left: 0;
}

::v-deep .title.noEdit {
    padding-left: 5px !important;
}

.module_interaction_dialog {
    display: flex;
    flex-flow: row;
    align-items: center;
    width: 100%;
}

::v-deep #navbox {
    padding: 20px 20px 15px 20px;
}

::v-deep #trackinglistContent .ada-table th {
    transition: all .3s ease-in-out;

    &.hide {
        min-width: 0 !important;
        width: 0 !important;
        padding: 0;
        overflow: hidden;
        white-space: pre;

        .table-header {
            width: 0;
            margin: 0;
            padding: 0;
            border: none;
        }
    }
}

::v-deep .mainTable {
    .table-header-row {
        float: left
    }
}

::v-deep .templateSelection {
    .modal-container {
        flex-flow: column;
    }

    h4 {
        margin-top: 0;
    }
}

::v-deep .addFormulaDialog .inputContainer {
    input:disabled {
        background: transparent;
        border-color: $lightGrey !important;
        border-bottom: 1px solid $lightGrey !important;
        color: grey !important;
        cursor: not-allowed;
    }

    input:disabled ~ span {
        color: #b4b4b4 !important;
    }
}

.addFormulaDialog {

    .checkboxWrapper {
        padding: 5px 0;
        position: relative;

        &:first-child {
            padding-top: 0;
        }

        .icon {
            top: inherit;
            right: inherit;
            color: $grey;
        }
    }

    ::v-deep .error input {
        border-color: $pink !important;
    }

    .errorMesage {
        color: $pink;
        font-size: 15px;
        margin-top: 10px;
    }

    .standardEvents {
        margin-bottom: 20px;

        &.error {
            border: 1px solid $pink;
            padding: 10px 0;
        }
    }
}
</style>